import type { ApiErrorResponse } from "types/shared/api-error-response.type";
import { AxiosError } from "axios";
import { ErrorMessage } from "types/shared/error-message.type";

export const getErrorMessage = (
  error: unknown
): { errorMsg: ErrorMessage[] } => {
  const err = error as AxiosError<ApiErrorResponse | string | unknown>;
  const data = err?.response?.data;
  const fallbackMsg = "Something went wrong. Contact customer service.";

  // If the server returned a problem-details style object
  if (data && typeof data === "object" && "title" in data && "status" in data) {
    const d = data as ApiErrorResponse;

    // If there are structured errors, return them
    if (Array.isArray(d.errors) && d.errors.length > 0) {
      return { errorMsg: d.errors };
    }

    // for status code >= 500, build one generic ErrorMessage
    const message = d.detail?.trim() || fallbackMsg;
    return {
      errorMsg: [
        {
          code: d.status.toString(),
          message,
        },
      ],
    };
  }

  // Final fallback , continue with regualr flow of handling error messages
  return {
    errorMsg: [],
  };
};
